<template>
  <span class="text-body-1 text-medium-emphasis">
    {{
      $t('price.priceVatStar').toString() +
      (portalSettings.grossPortal
        ? $t('includingVatHint', [getVatRateText(portalSettings.vatRatePercent, portalSettings)])
        : $t('excludingVatHint', [getVatRateText(portalSettings.vatRatePercent, portalSettings)]))
    }}
  </span>
</template>

<script lang="ts">
import { PortalSettings } from '@/modules/portalSettings/types'
import { defineComponent, PropType } from 'vue'
import { getVatRateText } from '@/modules/portalSettings/helpers'

export default defineComponent({
  name: 'VatHint',
  props: {
    portalSettings: {
      type: Object as PropType<PortalSettings>,
      required: true
    }
  },
  methods: {
    getVatRateText
  }
})
</script>
